import { connect } from 'react-redux';
import Exams from './exams';
import { onSetActiveTestRun, selectExam, onStartTest, onLoadExams, onLoadTests } from '../../reducers/test.reducers';
import { navigate } from '../../reducers/navigator.reducers';
import { onExportContent, onLoadCourses } from '../../reducers/course.reducers';

const mapStateToProps = state => ({
  isLoading: state.tests.isLoadingExamTests,
  groups: state.tests.tests,
  testRuns: state.tests.testRuns,
  exams: state.tests.exams,
  testGroups: state.tests.tests,
  courseGroups: state.courses.courses,
});

const mapDispatchToProps = dispatch => ({
  startNewTestRun: (test, examId) => {
    dispatch(selectExam(test));
    dispatch(onStartTest({ testId: test.id, examId }));
  },
  loadTest: test => dispatch(selectExam(test)),
  setTestRun: testRun => dispatch(onSetActiveTestRun(testRun)),
  navigate: route => dispatch(navigate({ route })),
  onExportContent: url => dispatch(onExportContent(url)),
  loadExams: () => dispatch(onLoadExams()),
  onLoadCourses: () => dispatch(onLoadCourses()),
  onLoadTests: () => dispatch(onLoadTests()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Exams);



// WEBPACK FOOTER //
// ./src/app/main/exams/exams.container.js